const SYMBOLS = { EUR: "€", CHF: "CHF", USD: "$", GBP: "£", BRL: "R$", CAD: "CA$", SEK: "kr", NOK: "kr", DKK: "kr", PLN: "zł" };
// Locale activo para formatos por defecto. El I18nProvider lo actualiza al cambiar de idioma.
const LOCALE_MAP = { es: "es-ES", en: "en-GB", fr: "fr-FR", pt: "pt-PT", it: "it-IT" };
let _locale = "es-ES";
export function setFormatLocale(l) { _locale = LOCALE_MAP[l] || l || "es-ES"; }

export function money(amount, currency = "EUR", locale = _locale) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency, minimumFractionDigits: 2 }).format(n);
  } catch {
    return `${n.toFixed(2)} ${SYMBOLS[currency] || currency}`;
  }
}

export function num(amount, locale = _locale) {
  return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(amount || 0));
}

export function fmtDate(d, locale = _locale) {
  if (!d) return "—";
  const date = typeof d === "string" ? new Date(d.length <= 10 ? d + "T00:00:00" : d) : d;
  return new Intl.DateTimeFormat(locale, { day: "2-digit", month: "short", year: "numeric" }).format(date);
}

export function daysUntil(d) {
  if (!d) return null;
  const target = new Date(d + "T00:00:00");
  return Math.ceil((target - new Date(new Date().toDateString())) / 86400000);
}

export const CHART_COLORS = ["#0299A0", "#075E62", "#5F8588", "#A8D2C8", "#A8C5CC", "#46636A"];

export const COUNTRY_NAMES = {
  ES: { es: "España", en: "Spain", fr: "Espagne", pt: "Espanha", it: "Spagna" },
  FR: { es: "Francia", en: "France", fr: "France", pt: "França", it: "Francia" },
  CH: { es: "Suiza", en: "Switzerland", fr: "Suisse", pt: "Suíça", it: "Svizzera" },
  PT: { es: "Portugal", en: "Portugal", fr: "Portugal", pt: "Portugal", it: "Portogallo" },
  IT: { es: "Italia", en: "Italy", fr: "Italie", pt: "Itália", it: "Italia" },
  GB: { es: "Reino Unido", en: "United Kingdom", fr: "Royaume-Uni", pt: "Reino Unido", it: "Regno Unito" },
  US: { es: "Estados Unidos", en: "United States", fr: "États-Unis", pt: "Estados Unidos", it: "Stati Uniti" },
  BR: { es: "Brasil", en: "Brazil", fr: "Brésil", pt: "Brasil", it: "Brasile" },
};
export const countryName = (code, locale) => (COUNTRY_NAMES[code] && (COUNTRY_NAMES[code][locale] || COUNTRY_NAMES[code].es)) || code;
